export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-it-IT.901885c2.xlsx";